import React from 'react';
import Logo from './Logo';

const Transaksi = ({ onBack, activeBottomTab, setActiveBottomTab }) => {
  // Dummy invoice data
  const invoiceData = {
    invoiceCode: 'INV2509170001',
    customerName: 'Ir. Eni Sugiarti',
    orderDate: '17 September 2025'
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary text-lg">Transaksi</span>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-24 bg-gray-50">
          {/* Invoice Card */}
          <section className="px-4 pt-6">
            <div className="bg-white rounded-2xl shadow-lg p-6">
              {/* Invoice Code */}
              <div className="text-center mb-6">
                <p className="text-gray-500 text-sm font-medium">Kode Invoice</p>
                <p className="text-accent font-bold text-2xl mt-1">{invoiceData.invoiceCode}</p>
              </div>

              {/* Customer Info and Order Date */}
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div>
                  <p className="text-gray-500 text-sm font-medium">Nama Customer</p>
                  <p className="text-primary font-bold text-lg mt-1">{invoiceData.customerName}</p>
                </div>
                <div>
                  <p className="text-gray-500 text-sm font-medium">Tanggal Pesan</p>
                  <p className="text-primary font-bold text-lg mt-1">{invoiceData.orderDate}</p>
                </div>
              </div>

              {/* Invoice Button */}
              <button className="w-full bg-gradient-to-r from-accent to-orange-500 text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center space-x-3 hover:from-accent/90 hover:to-orange-500/90 transition-all duration-300 shadow-lg">
                <i className="fa-solid fa-print text-xl"></i>
                <span className="text-lg">Invoice</span>
              </button>
            </div>
          </section>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  onBack();
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'savings' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('savings');
                  onBack();
                }}
              >
                <i className="fa-solid fa-piggy-bank text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Tabungan</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => setActiveBottomTab('products')}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Produk</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'investment' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('investment');
                  onBack();
                }}
              >
                <i className="fa-solid fa-arrow-trend-up text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Investasi</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  onBack();
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Transaksi;
